import { useRecoilValue } from 'recoil'
import parametersAtom from '@/pages/Parameters/parameters.atom.ts'
import { useMemo, useRef, useState } from 'react'
import DropdownListItem from '@/shared/Dropdowns/DropdownListItem'
import Tag from '@/shared/Tags/Tag'
import usePopup from '@/shared/hooks/usePopup.ts'
import SearchInput from '@/shared/Inputs/SearchInput'
import DropdownFadeInPanel from '@/shared/Dropdowns/DropdownFadeInPanel'
import { Virtuoso } from 'react-virtuoso'
import useDebounce from '@/shared/hooks/useDebounce.ts'
import { IParameter } from '@/pages/Parameters/parameters.types.ts'

interface IProps {
  onParameterAdd: (p: IParameter['id']) => void
  dropdownPosition?: 'left' | 'right'
}

const AddParameterTag = (props: IProps) => {
  const parameters = useRecoilValue(parametersAtom).items

  const ref = useRef<HTMLDivElement>(null)

  const { open, setOpen } = usePopup(ref)
  const [searchText, setSearchText] = useState('')
  const debouncedSearchText = useDebounce(searchText, 500)

  const searchResults = useMemo(() => {
    if (!searchText) {
      return parameters
    }

    const sl = searchText.toLowerCase()
    return parameters.filter((p) => p.name.toLowerCase().includes(sl) || p.sourceId.toLowerCase().includes(sl))
  }, [debouncedSearchText])

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <Tag
        color={open ? 'purple' : 'doted'}
        style={{ cursor: 'pointer', width: '110px', textAlign: 'center' }}
        onClick={() => setOpen((prev) => !prev)}
      >
        {open ? '× Закрыть' : '+ Добавить'}
      </Tag>
      <DropdownFadeInPanel
        open={open}
        style={{ backgroundColor: 'white', zIndex: 100, width: '300px' }}
        position={props.dropdownPosition || 'left'}
      >
        <div style={{ padding: '12px' }}>
          <SearchInput
            value={searchText}
            name="searchText"
            onChange={setSearchText}
            placeHolder="Введите название либо id..."
          />
        </div>
        <Virtuoso
          style={{ height: '200px', scrollbarWidth: 'thin' }}
          totalCount={searchResults.length}
          itemContent={(index) => (
            <DropdownListItem
              key={searchResults[index].id}
              onClick={() => {
                props.onParameterAdd(searchResults[index].id)
                setOpen(false)
              }}
            >
              <p className="text-nm">{searchResults[index].name}</p>
            </DropdownListItem>
          )}
        ></Virtuoso>
      </DropdownFadeInPanel>
    </div>
  )
}

export default AddParameterTag
